import React from 'react';

import PresenceFilter from './Filter';
import Toolbar from './Toolbar';
import { IProps } from './types';

const FilterOptions = ({
  finishedEvent,
  refreshData,
  loadData,
  handleOpenModalLink,
  handleSubmitFilter,
  handleOpenModalResendTicket,
  handleCheckinAttendances,
  handleOpenModalLabelManager,
  handleOpenModalSendEmailToParticipants,
  disableLabelManager
}: IProps) => {
  return (
    <>
      <PresenceFilter handleSubmitFilter={handleSubmitFilter} />

      <Toolbar
        finishedEvent={finishedEvent}
        disableLabelManager={disableLabelManager}
        refreshData={refreshData}
        loadData={loadData}
        handleSubmitFilter={handleSubmitFilter}
        handleOpenModalResendTicket={handleOpenModalResendTicket}
        handleOpenModalLink={handleOpenModalLink}
        handleCheckinAttendances={handleCheckinAttendances}
        handleOpenModalLabelManager={handleOpenModalLabelManager}
        handleOpenModalSendEmailToParticipants={
          false ? () => handleOpenModalSendEmailToParticipants('toSelected') : null
        }
      />
    </>
  );
};

export default FilterOptions;
